import React, { useState } from "react";
import Alert from "../../../controls/Alert";
import __ from "lodash";
import moment from "moment";

const AddPermitValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";
  const permitTypes = [{"code":"OVERFLIGHT","value":"Overflight"},{"code":"LANDING","value":"Landing"}];
  let permitType = __.find(permitTypes, {value: record.permitType});
  if (!permitType)
    permitType = {};

  if (!error && record.newPermitMode && !record.permitType ) {
    error = true;
    errorMessage = "Please select the required 'Permit Type'";
  }
  if (!error && record.newPermitMode && !record.arrangedBy ) {
    error = true;
    errorMessage = "Please select who is assigned to arrange the permit";
  }
  if (!error && permitType.code === "LANDING"  && !record.airportCode ) {
    error = true;
    errorMessage = "'Destination Airport' must be selected for Landing Permits";
  }
  if (!error && permitType.code === "OVERFLIGHT"  && !record.countryCode ) {
    error = true;
    errorMessage = "'Overflight Country' must be selected for Overflight Permits";
  }
  const validFrom = moment(record.validFrom);
  const validTo = moment(record.validTo);
  if (!error && validTo.isBefore(validFrom)) {
    error = true;
    errorMessage = "'Required to Date' must be after 'Required to Date'";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );

}

export default AddPermitValidator;